import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

export interface InventoryAllocationProject {
  salesOrderId: string;
  gpSalesOrderNumber: string;
  customerName: string;
  allocatedQuantity: number;
  earliestPromisedShipDate: string | null;
}

export interface InventoryAllocationItem {
  partNumber: string;
  gpOnHand: number;
  shadowInventory: number;
  allocatedQuantity: number;
  effectiveAvailable: number;
  projects: InventoryAllocationProject[];
}

export interface InventoryAllocationsResponse {
  data: InventoryAllocationItem[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
}

interface InventoryAllocationsFilters {
  partNumber?: string;
  limit?: number;
  offset?: number;
}

async function fetchInventoryAllocations(
  filters: InventoryAllocationsFilters = {}
): Promise<InventoryAllocationsResponse> {
  const params = new URLSearchParams();
  if (filters.partNumber) params.set('partNumber', filters.partNumber);
  if (filters.limit !== undefined) params.set('limit', String(filters.limit));
  if (filters.offset !== undefined) params.set('offset', String(filters.offset));

  const query = params.toString();
  const path = `/api/v1/inventory/allocations${query ? `?${query}` : ''}`;
  return apiFetch<InventoryAllocationsResponse>(path);
}

export function useInventoryAllocations(filters: InventoryAllocationsFilters = {}) {
  return useQuery({
    queryKey: ['inventory', 'allocations', filters],
    queryFn: () => fetchInventoryAllocations(filters),
    staleTime: 30000,
  });
}
